module.exports = __webpack_public_path__ + "assets/8515c8a168b896b9f3091582fc911359.mp4";